const generateFontFaceRule = ({
  fontFamily,
  fontUrl,
  fontFormat,
  fontWeight,
  fontStyle,
}) => `
    @font-face {
      font-family: "${fontFamily}";
      src: url("${fontUrl}") format("${fontFormat}");
      font-weight: ${fontWeight};
      font-style: ${fontStyle || "normal"};
    }
  `;

export const loadFonts = (fonts) => {
  // Vérifier si une feuille de style de polices existe déjà
  const existingStyle = document.getElementById("dynamic-fonts");
  if (existingStyle) {
    document.head.removeChild(existingStyle);
  }

  // Créer une nouvelle feuille de style
  const style = document.createElement("style");
  style.id = "dynamic-fonts";

  // Générer les règles @font-face
  const fontFaceRules = fonts.map(generateFontFaceRule).join("\n");
  style.appendChild(document.createTextNode(fontFaceRules));

  // Ajouter la feuille de style au document
  document.head.appendChild(style);

  return style;
};

export const preloadFonts = (fonts) => {
  const fontPromises = fonts.map((font) => {
    return new Promise((resolve, reject) => {
      const link = document.createElement("link");
      link.rel = "preload";
      link.href = font.fontUrl;
      link.as = "font";
      link.fontFormat = font.fontFormat;
      link.crossOrigin = "anonymous";
      link.onload = resolve;
      link.onerror = reject;

      document.head.appendChild(link);
    });
  });

  return Promise.all(fontPromises);
};
